import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'about',
  `
    START_QUIZ
    SET_QUIZ_CARD_NAME
    FLIP_QUIZ_CARD
    NEXT_QUIZ_CARD
  `
);
